import * as FromLearningModule from "src/app/store/learning-module/selectors";
import { Pipe, PipeTransform } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { RootState } from "src/app/store";
import { map } from "rxjs/operators";

@Pipe({ name: "isLastStepOfChallenge" })
export class IsLastStepOfChallengePipe implements PipeTransform {
  constructor(private store: Store<RootState>) {}

  public transform(challengeId: string, chapterId: string): Observable<boolean> {
    return this.store.select(FromLearningModule.selectChallengeSteps(chapterId)).pipe(map(steps => [...steps].pop()?.id === challengeId));
  }
}
